export type FreestarPageTargeting = Record<string, string | string[] | number | boolean | undefined | null>;

type FreestarAdSlotApi = {
  clearPageTargeting: (key?: string) => void;
  setPageTargeting: (key: string, value: string | string[]) => void;
  queueAdCalls?: (queue: boolean) => void;
  releaseQueuedAds?: () => void;
  trackPageview?: () => void;
};

const normalizeTargetingValue = (value: string | string[] | number | boolean): string | string[] => {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'boolean' || typeof value === 'number') return String(value);
  return value;
};

export const normalizeFreestarPageTargeting = (
  targeting?: FreestarPageTargeting | null,
): Record<string, string | string[]> => {
  if (!targeting) return {};
  const normalized: Record<string, string | string[]> = {};
  Object.entries(targeting).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    normalized[key] = normalizeTargetingValue(value);
  });
  return normalized;
};

export const applyFreestarPageTargeting = async (
  targeting?: FreestarPageTargeting | null,
  options?: { trackPageview?: boolean; holdAuctions?: boolean },
): Promise<void> => {
  if (typeof window === 'undefined') return;

  const FreestarAdSlotModule = await import('@freestar/pubfig-adslot-react-component');
  const FreestarAdSlotApi = FreestarAdSlotModule.default as FreestarAdSlotApi;
  const normalized = normalizeFreestarPageTargeting(targeting);
  const holdAuctions = options?.holdAuctions ?? true;

  if (holdAuctions) {
    FreestarAdSlotApi.queueAdCalls?.(true);
  }

  FreestarAdSlotApi.clearPageTargeting();
  Object.entries(normalized).forEach(([key, value]) => {
    FreestarAdSlotApi.setPageTargeting(key, value);
  });

  if (holdAuctions) {
    FreestarAdSlotApi.queueAdCalls?.(false);
    FreestarAdSlotApi.releaseQueuedAds?.();
  }

  if (options?.trackPageview) {
    FreestarAdSlotApi.trackPageview?.();
  }
};
